import React, {useEffect, useState} from 'react'
import qs from 'qs'
import _ from 'lodash'
import {isMobile} from '../util'
import MobileLink from './MobileLink/MobileLink'
import styled from 'styled-components'
import {WEB_BASE} from './util'
import ErrorPage from '../components/ErrorPage/ErrorPage'
import PageSpinner from '../components/PageSpinner/PageSpinner'

const CenterContainer = styled.div`
    width: 100vw;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 50px 0;
`

const UploadPhoto = ({location}) => {
    const [showMobileLink, setShowMobileLink] = useState(false)
    const [error, setError] = useState(null)

    const search = qs.parse(location.search.substring(1))
    const organisationIdStr = search.o
    const profileIdStr = search.p

    useEffect(() => {
        if (isMobile) {
            setShowMobileLink(true)
        } else {
            window.location = `${WEB_BASE}/${organisationIdStr}?editProfileId=${profileIdStr}&modal=editProfile`
        }
    }, [])

    if (error)
        return (
            <CenterContainer>
                <ErrorPage message={error} />
            </CenterContainer>
        )

    if (showMobileLink) return <MobileLink link={`namesandfaces://`} />

    return <PageSpinner />
}

export default UploadPhoto
